__turbopack_context__.v({
  "Bottom": "ImageSlider-module-sass-module__xMQ_zW__Bottom",
  "Caption": "ImageSlider-module-sass-module__xMQ_zW__Caption",
  "Content": "ImageSlider-module-sass-module__xMQ_zW__Content",
  "Controls": "ImageSlider-module-sass-module__xMQ_zW__Controls",
  "Disabled": "ImageSlider-module-sass-module__xMQ_zW__Disabled",
  "Image": "ImageSlider-module-sass-module__xMQ_zW__Image",
  "ImageSlider": "ImageSlider-module-sass-module__xMQ_zW__ImageSlider",
  "Top": "ImageSlider-module-sass-module__xMQ_zW__Top",
  "Year": "ImageSlider-module-sass-module__xMQ_zW__Year",
});
